module.exports = __webpack_public_path__ + "462eaaa671128476585d9758a7250315.MP3";